module.exports = __webpack_public_path__ + "img/059-gabon.ad4d7405.svg";